// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"styles_ratingContainer__TF1HA"};